/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined, LoadingOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import Table from '../../../../../components/Table';
import { isEmpty } from 'lodash';
import { makeColumnFilteringProps } from '../../shared';

const FORECAST_TYPE = Object.freeze({
    3: 'Pickup',
    4: 'Persona',
    5: 'Pickup ADR',
    6: 'Segment',
    7: 'Segment with uplift',
});

const PropertyDetails = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const intl = useIntl();
    const [fetching, setFetching] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let response = {};
        if (individualPropertyID) {
            response = await statsService({
                token,
            }).getAccountManagementPropertyDetails({ propertyID: individualPropertyID });
        } else {
            response = await statsService({
                token,
            }).getAccountManagementPropertyDetails();
        }
        let propertyData = response?.data?.map((d) => ({
            ...d,
            groupName: d.groupName || '',
            personaParent: d.personaParent || '',
            recommendationSchedule: d.recommendationSchedule ? d.recommendationSchedule.toString() : '',
            forecastSchedule: d.forecastSchedule ? d.forecastSchedule.toString() : '',
        }));
        if (!isEmpty(propertyUuids)) {
            propertyData = propertyData.filter(({ uuid }) => propertyUuids.includes(uuid));
        }
        setData(propertyData);
        setFetching(false);
        setFetched(true);
    };

    const renderFlag = (val) =>
        val === 1 ? <CheckOutlined style={{ color: '#52c41a' }} /> : <CloseOutlined style={{ color: '#ff4d4f' }} />;

    useEffect(() => {
        loadData();
    }, [propertyUuids]);

    const columns = [
        {
            title: intl.formatMessage(messages.name),
            dataIndex: 'name',
            align: 'left',
            width: '200px',
            sorter: (a, b) => a.name.localeCompare(b.name),
            defaultSortOrder: 'ascend',
            fixed: 'left',
            ...makeColumnFilteringProps(data, 'name'),
        },
        {
            title: intl.formatMessage(messages.pms),
            dataIndex: 'vendor',
            align: 'center',
            width: '150px',
            sorter: (a, b) => a.vendor.localeCompare(b.vendor),
            ...makeColumnFilteringProps(data, 'vendor'),
        },
        {
            title: intl.formatMessage(messages.groupName),
            dataIndex: 'groupName',
            align: 'center',
            width: '200px',
            sorter: (a, b) => a.groupName.localeCompare(b.groupName),
            ...makeColumnFilteringProps(data, 'groupName'),
        },
        {
            title: intl.formatMessage(messages.cardinalRecommendations),
            dataIndex: 'cardinalRecommendationGeneration',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.cardinalRecommendationGeneration - b.cardinalRecommendationGeneration,
        },
        {
            title: intl.formatMessage(messages.aeRecommendations),
            dataIndex: 'aeRecommendationGeneration',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.aeRecommendationGeneration - b.aeRecommendationGeneration,
        },
        {
            title: intl.formatMessage(messages.cardinalSend2Way),
            dataIndex: 'cardinalSendTwoWay',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.cardinalSendTwoWay - b.cardinalSendTwoWay,
        },
        {
            title: intl.formatMessage(messages.forecastGeneration),
            dataIndex: 'forecastGeneration',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.forecastGeneration - b.forecastGeneration,
        },
        {
            title: intl.formatMessage(messages.otaManagedBy),
            dataIndex: 'otaManagedBy',
            align: 'center',
            width: '100px',
            sorter: (a, b) => a.otaManagedBy - b.otaManagedBy,
        },
        {
            title: intl.formatMessage(messages.otaDemand),
            dataIndex: 'otaInsightsDemand',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.otaInsightsDemand - b.otaInsightsDemand,
        },
        {
            title: intl.formatMessage(messages.otaParity),
            dataIndex: 'otaInsightsParity',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.otaInsightsParity - b.otaInsightsParity,
        },
        {
            title: intl.formatMessage(messages.otaRates),
            dataIndex: 'otaInsightsRates',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.otaInsightsRates - b.otaInsightsRates,
        },

        {
            title: intl.formatMessage(messages.guestRevu),
            dataIndex: 'guestrevu',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.guestrevu - b.guestrevu,
        },
        {
            title: intl.formatMessage(messages.groupBlocks),
            dataIndex: 'groupBlocks',
            align: 'center',
            width: '100px',
            render: renderFlag,
            sorter: (a, b) => a.groupBlocks - b.groupBlocks,
        },
        {
            title: intl.formatMessage(messages.forecastType),
            dataIndex: 'forecastType',
            align: 'center',
            width: '150px',
            render: (value) => FORECAST_TYPE[value],
            sorter: (a, b) => a.forecastType - b.forecastType,
        },
        {
            title: intl.formatMessage(messages.rateCode),
            dataIndex: 'primaryRatePlanCode',
            align: 'center',
            width: '150px',
            sorter: (a, b) => a.primaryRatePlanCode.localeCompare(b.primaryRatePlanCode),
            ...makeColumnFilteringProps(data, 'primaryRatePlanCode'),
        },
        {
            title: intl.formatMessage(messages.personaParent),
            dataIndex: 'personaParent',
            align: 'center',
            width: '150px',
            sorter: (a, b) => a.personaParent.localeCompare(b.personaParent),
            ...makeColumnFilteringProps(data, 'personaParent'),
        },
        {
            title: intl.formatMessage(messages.recommendationSchedule),
            dataIndex: 'recommendationSchedule',
            align: 'center',
            width: '150px',
            sorter: (a, b) => a.recommendationSchedule.localeCompare(b.recommendationSchedule),
        },
        {
            title: intl.formatMessage(messages.forecastSchedule),
            dataIndex: 'forecastSchedule',
            align: 'center',
            width: '150px',
            sorter: (a, b) => a.forecastSchedule.localeCompare(b.forecastSchedule),
        },
    ];

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                {fetching && <LoadingOutlined style={{ marginRight: '8px' }} />}
                {!fetching && fetched && (
                    <>
                        <Table
                            dataSource={data}
                            columns={columns}
                            pagination={{
                                pageSize: 31,
                                hideOnSinglePage: true,
                            }}
                            rowKey="name"
                            tableLayout="auto"
                            size="small"
                            scroll={{ y: 360, x: 2200 }}
                        />
                    </>
                )}
            </ScrollableBodyTall>
        </>
    );
};

PropertyDetails.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PropertyDetails;
